// extracted by mini-css-extract-plugin
export default {"card":"cardPreview_card__hJpBH","containerPrice":"cardPreview_containerPrice__K8dD2","finalPrice":"cardPreview_finalPrice__Zod05","discount":"cardPreview_discount__t7dDj"};